import { Dispatch, SetStateAction, useEffect } from "react";
import { Modal } from "components/modal/modal";
import {
  ButtonCTA,
  ModalContainer,
  ModalText
} from "./user-profile-form.styles";
import Image from "next/legacy/image";
import LoginModalImg from "public/assets/login-modal.png";
import trackEvent from "services/mixpanel/mixpanel";
import { eventNames } from "services/mixpanel/events";
import {
  createSuperPropertiesForTrackingEvent,
  getSourceInfoEvent
} from "utils/mixpanel/mixpanel-utils";
import { useAuth } from "stores/auth/auth-context";
import { useGetCurrentPlatform } from "hooks/use-media-query/use-get-currrent-platform";
import { useRedirectAfterLogin } from "hooks/use-redirect-after-login/use-redirect-after-login";

interface ILoginSuccessModalProps {
  isSuccessModalOpen: boolean;
  setIsSuccessModalOpen: Dispatch<SetStateAction<boolean>>;
  headerMessage: {
    primaryText: string;
    secondaryText: string;
  };
}

const LoginSuccessModal: React.FC<ILoginSuccessModalProps> = ({
  isSuccessModalOpen,
  setIsSuccessModalOpen,
  headerMessage
}) => {
  const { user } = useAuth();
  const { redirectAfterLogin } = useRedirectAfterLogin();
  const currentPlatform = useGetCurrentPlatform();

  useEffect(() => {
    if (isSuccessModalOpen) {
      trackEvent({
        eventName: eventNames.successfulRegisterPopupShown,
        payload: {
          ...createSuperPropertiesForTrackingEvent({ useAuthData: user }),
          sourceInfo: getSourceInfoEvent(currentPlatform)
        }
      });
    }
  }, [isSuccessModalOpen]);

  return (
    <Modal
      onClose={() => {
        setIsSuccessModalOpen(false);
        trackEvent({
          eventName: eventNames.closedSuccessfulRegisterPopup,
          payload: {
            ...createSuperPropertiesForTrackingEvent({ useAuthData: user }),
            sourceInfo: getSourceInfoEvent(currentPlatform)
          }
        });
        redirectAfterLogin();
      }}
      isOpen={isSuccessModalOpen}
    >
      <ModalContainer>
        <Image layout="fixed" src={LoginModalImg} alt="Login Modal Image" />
        <ModalText>{headerMessage.primaryText}</ModalText>
        <ModalText>{headerMessage.secondaryText}</ModalText>
        <ButtonCTA
          data-testid="okay-button"
          variant="primary"
          onClick={() => {
            setIsSuccessModalOpen(false);

            trackEvent({
              eventName: eventNames.continueClickedOnSuccessfullRegisterPopup,
              payload: {
                ...createSuperPropertiesForTrackingEvent({ useAuthData: user }),
                sourceInfo: getSourceInfoEvent(currentPlatform)
              }
            });
            redirectAfterLogin();
          }}
        >
          Oke, sip
        </ButtonCTA>
      </ModalContainer>
    </Modal>
  );
};

export { LoginSuccessModal };
